
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.174 12.916c-.018-.008-.035-.017-.053-.024-.138-.062-.274-.127-.415-.183a6 6 0 10-7.412 0c-.14.056-.277.121-.415.183l-.054.024a9.946 9.946 0 00-5.76 7.976 1.001 1.001 0 001.99.216A7.945 7.945 0 018.04 15.05l3.252 3.251a1 1 0 001.414 0l3.252-3.251a7.944 7.944 0 013.987 6.058 1 1 0 001.988-.216 9.947 9.947 0 00-5.759-7.976zM8.041 7.594a3.977 3.977 0 017.918 0H8.041zM12 16.18l-1.937-1.937a7.835 7.835 0 013.874 0L12 16.18zM12 12a4.003 4.003 0 01-3.664-2.406h7.328A4.003 4.003 0 0112 12z","fill":"#000"}})])
          )
        }
      }
    